import {type IAsset} from '@netx/core-asset-next/schema';
import {isMobile} from '@netx/core-next/utils/browser';
import {getPreference} from '@netx/core-user/utils';
import {AssetProjectPref} from './constants';

export const assetProjectEnabled = () =>
	getPreference(AssetProjectPref.ENABLED, true);

export const canManageAssetProject = (asset?: IAsset) =>
	!isMobile(false) &&
	assetProjectEnabled() &&
	asset?.fileFormatFamily.includes('image') === true;
